import { render, staticRenderFns } from "./TestVersion.vue?vue&type=template&id=690ec041&scoped=true&"
import script from "./TestVersion.vue?vue&type=script&lang=js&"
export * from "./TestVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690ec041",
  null
  
)

export default component.exports